<template>
  <div>
    <div id="profilContainer"></div>
  </div>
</template>

<script>
import axios from "axios";
import * as Highcharts from "highcharts/highcharts.js";
import * as turf from "@turf/turf";
import * as Annotations from "highcharts/modules/annotations";

export default {
  props: ["parcours", "lines"],
  data() {
    return {
      profil_chart: {},
      elevation_profil: [],
      min_elevation: 0,
      points_annotations: [],
      coureurs_annotations: [],
    };
  },
  watch: {
    lines: function (newVal, oldVal) {
      // watch it
      this.buildElevationProfilDatas();
      this.initProfil();
      this.displayPoints();
    },
  },
  methods: {
    initProfil() {
      var _this = this;
      this.profil_chart = Highcharts.chart("profilContainer", {
        chart: {
          height: 200,
          type: "area",
          zoomType: "x",
          panning: false,
          panKey: "shift",
          backgroundColor: "#e9f1f3",
          scrollablePlotArea: {
            minWidth: 600,
          },
        },
        title: {
          text: null,
        },
        xAxis: {
          labels: {
            format: "{value} km",
            style: {
              color: "#2f3a45",
            },
          },
          title: {
            text: null,
          },
        },
        yAxis: {
          min: _this.min_elevation,
          startOnTick: false,
          endOnTick: false,
          maxPadding: 0.35,
          gridLineColor: "rgba(47, 58, 69, 0.2)",
          title: {
            text: null,
          },
          labels: {
            format: "{value} m",
            style: {
              color: "#2f3a45",
            },
          },
        },
        tooltip: {
          enabled: false,
          followTouchMove: false,
          followPointer: false,
        },

        legend: {
          enabled: false,
        },

        series: _this.elevation_profil,

        plotOptions: {
          series: {
            point: {
              events: {
                mouseOver: function (p) {
                  _this.$emit("focus_point", p.target.x);
                },
              },
            },
            events: {
              mouseOut: function () {
                _this.$emit("focus_point", 0);
              },
            },
          },
        },
      });
    },
    getPointPosition: function (distance) {
      var best_position = [];
      for (var i = 0; i < this.elevation_profil[0].data.length; i++) {
        if (distance > this.elevation_profil[0].data[i][0]) {
          best_position = this.elevation_profil[0].data[i];
        } else {
          break;
        }
      }
      return best_position;
    },

    displayPoints: function () {
      this.removeOldPlotLines();
      if (this.parcours.list_points) {
        for (var i = 0; i < this.parcours.list_points.length; i++) {
          var point = this.parcours.list_points[i];
          var point_position = this.getPointPosition(point.distance_depuis_depart);
          let plotLine = {
            color: "#2f3a45",
            width: 1,
            value: point_position[0],
            id: point.nom_affiche,
            label: {
              useHTML: true,
              text: "<div style='background-color:#2f3a45;color:white;padding: 3px 10px;border-radius:5px;'>" + point.nom_affiche + "</div>",
              rotation: 0,
              align: "center",
              style: {
                color: "#2f3a45",
              },
            },
          };

          this.points_annotations.push(plotLine);
          this.profil_chart.xAxis[0].addPlotLine(plotLine);
        }
      }
    },

    removeOldPlotLines: function () {
      for (var i = this.points_annotations.length - 1; i >= 0; i--) {
        this.profil_chart.xAxis[0].removePlotLine(this.points_annotations[i].id);
      }
      this.points_annotations = [];
    },
    buildElevationProfilDatas: function () {
      var declinaison_elevation_datas = [[], [], [], [], []];

      var last_elevation = 0;
      for (var i = 0; i < this.lines.length; i++) {
        if (this.lines[i][2]) {
          last_elevation = this.lines[i][2];
        }
        if (i == 0) {
          declinaison_elevation_datas[0].push([0, parseFloat(last_elevation.toFixed(1))]);
          declinaison_elevation_datas[1].push([0, parseFloat((last_elevation / 1.2).toFixed(1))]);
          declinaison_elevation_datas[2].push([0, parseFloat((last_elevation / 1.4).toFixed(1))]);
          declinaison_elevation_datas[3].push([0, parseFloat((last_elevation / 1.6).toFixed(1))]);
          declinaison_elevation_datas[4].push([0, parseFloat((last_elevation / 1.8).toFixed(1))]);
        } else {
          var before = i - 1;
          var from = turf.point(this.lines[before]);
          var to = turf.point(this.lines[i]);
          var options = {
            units: "kilometers",
          };
          var distance = turf.distance(from, to, options) + declinaison_elevation_datas[0][before][0];
          distance = parseFloat(distance);
          declinaison_elevation_datas[0].push([distance, parseInt(last_elevation.toFixed(1))]);
          declinaison_elevation_datas[1].push([distance, parseInt(last_elevation / 1.2)]);
          declinaison_elevation_datas[2].push([distance, parseInt(last_elevation / 1.5)]);
          declinaison_elevation_datas[3].push([distance, parseInt(last_elevation / 2)]);
          declinaison_elevation_datas[4].push([distance, parseInt(last_elevation / 4)]);
        }
      }
      var min_elevation = null;
      for (var j = 0; j < declinaison_elevation_datas[0].length; j++) {
        var elevation = declinaison_elevation_datas[0][j][1];
        if (min_elevation === null || elevation < min_elevation) {
          min_elevation = elevation;
        }
      }
      this.min_elevation = min_elevation;

      let series = [];
      for (var i = 0; i < declinaison_elevation_datas.length; i++) {
        let serie = {
          data: declinaison_elevation_datas[i],
          lineColor: "#f29200",
          color: "#f29200",
          fillOpacity: 0.1 * (1 / (i + 1)),
          name: "Elevation",
          marker: {
            enabled: false,
          },
          threshold: min_elevation,
        };
        series.push(serie);
      }

      this.elevation_profil = series;
    },
  },
  mounted() {
    this.buildElevationProfilDatas();
    this.initProfil();
    this.displayPoints();
  },
};
</script>

<style lang="scss" scoped>
</style>